
export default function rotator(element, config = {}) {
  let root = element instanceof HTMLElement ? element : document.querySelector(element);

  // Cannot find Rotator's root element
  if (!root) return;

  let { height = "1.2em", distance = "0.6em", bg = "transparent" } = config;
  let words = root.dataset.rotator.split(";");
  let count = 0;
  let maxCount = words.length - 2;


  let animationProps = {
    transform: "translateZ(-25px) rotateX(-90deg)",
  };

  let animationConfig = {
    delay: 500,
    iterations: 1,
    duration: 1000,
    fill: "forwards",
    easing: "cubic-bezier(.39,.59,.01,.99)",
  };

  root.innerHTML = `
    <div class="rotator">
      <span>${words[0]}</span><span>${words[1]}</span>
    </div>
  `;

  let animator = root.firstElementChild;
  let animation = animator.animate(animationProps, animationConfig);

  animation.onfinish = () => {
    if (count < maxCount) {
      animator.firstElementChild.textContent = words[count + 1];
      animator.lastElementChild.textContent = words[count + 2];
      animation.play();
    }

    else if (count === maxCount) {
      count = -2;
      animator.firstElementChild.textContent = words[words.length - 1];
      animator.lastElementChild.textContent = words[0];
      animation.play();
    }
    count++;
  }

  // Set CSS styles.
  document.head.appendChild(document.createElement("style")).textContent = `
    *[data-rotator] {
      --rotator-bg: ${bg};
      --rotator-height: ${height};
      --rotator-distance: ${distance};
      width: 100%;
      height: var(--rotator-height);
      position: relative;
      display: inline-flex;
    }
    *[data-rotator] .rotator {
      width: 100%;
      transform-style: preserve-3d;
      transform: translateZ(calc(-1 * var(--rotator-distance)));
    }
    *[data-rotator] .rotator>*:first-child,
    *[data-rotator] .rotator>*:last-child {
      width: 100vw;
      height: 100%;
      display: flex;
      position: absolute;
      align-items: center;
      box-sizing: border-box;
      background-color: var(--rotator-bg);
    }
    *[data-rotator] .rotator>*:nth-child(1) {
      transform: rotateY(0deg) translateZ(var(--rotator-distance));
    }
    *[data-rotator] .rotator>*:nth-child(2) {
      transform: rotateX(90deg) translateZ(var(--rotator-distance));
    }
  `;

  return Object.freeze({
    stop() {
      animation.pause();
    },
    start() {
      animation.play();
    },
    reset() {
      animation.cancel();
      count = 0;
      animator.firstElementChild.textContent = words[0];
      animator.lastElementChild.textContent = words[1];
      animation.play();
    },
  });
}